import React from 'react';

import { ReactComponent as PointerIcon } from 'svg/pointer-down.svg';
import { createDropdownClassName } from './dropdownStyles';

type TProps = {
  text: string;
  onClick(): void;
};

export const DropdownLabel = ({ text, onClick }: TProps) => (
  <button className={createDropdownClassName('label')} onClick={onClick}>
    {text}
    <PointerIcon className={createDropdownClassName('arrow')} />
  </button>
);
